import React from 'react';
import NoData from 'components/_common/NoData';
import Loading from 'components/_common/Loading';
import SearchFilter from 'components/_common/SearchFilter';
import PageUtil from 'utils/Page.util';
import { PaginationControl } from 'react-bootstrap-pagination-control';
import { DateType, ReceptionItemKind, getReceptionStatus, getReceptionType, getProofType, getPaymentMethod, getDateType, ReceptionType } from 'enums/reception.enum';

const ReceptionV = ({
    params,
    setParams,
    onSearch,
    setSearch,
    onClearFilter,
    onClearManufactureMonthFilter,
    onOpenCreate,
    onOpenEdit,
    onChangeStatus,
    onTodaySearch,
}) => {
    const { list, isLoaded, error, search, kpiLoaded, kpiData } = params;

    const dateTypeOptions = getDateType();

    // 검색 매개변수 변경 핸들러
    const handleSearchChange = (field, value) => {
        const cur = PageUtil.deepCopy(params);
        if (field === 'startDate' || field === 'endDate') {
            cur.search[field] = value;
        } else {
            cur.search[field] = value;
        }
        setParams(cur);
    };

    // KPI 스켈레톤 로딩 컴포넌트
    const KPISkeleton = () => (
        <div className="mb-4">
            <div className="row g-3 mb-4">
                {[1, 2, 3, 4].map(i => (
                    <div key={i} className="col-md-3">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-flex justify-content-between align-items-center">
                                    <div style={{ width: '60%' }}>
                                        <div className="placeholder-glow">
                                            <span className="placeholder col-8"></span>
                                        </div>
                                        <div className="placeholder-glow mt-2">
                                            <span className="placeholder col-6"></span>
                                        </div>
                                    </div>
                                    <div>
                                        <div className="placeholder-glow">
                                            <span className="placeholder col-12" style={{ width: '40px', height: '40px' }}></span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );


    return (
        <>
            {isLoaded && error == null ? (
                <>
                    <div className="content-header">
                        <h1>
                            <span>접수관리</span>
                        </h1>
                    </div>

                    <div className="container-fluid">

                        {/* ===== KPI 섹션 시작 ===== */}
                        {!kpiLoaded ? (
                            <KPISkeleton />
                        ) : (
                            <div className="row mb-3">
                                <div className="col-12">
                                    <div className="card card-outline card-primary">
                                        <div className="card-header">
                                            <h3 className="card-title">
                                                <i className="fas fa-chart-line mr-2"></i>
                                                접수관리 현황
                                            </h3>
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                {/* 일일접수건수 */}
                                                <div className="col-md-3 col-sm-6">
                                                    <div className="info-box bg-info">
                                                        <span className="info-box-icon">
                                                            <i className="fas fa-clipboard-list"></i>
                                                        </span>
                                                        <div className="info-box-content">
                                                            <span className="info-box-text text-white">일일접수건수</span>
                                                            <span className="info-box-number text-white">
                                                                {kpiData.dailyReceptionCount.toLocaleString()}건
                                                            </span>
                                                            <div className="progress" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                                                                <div className="progress-bar" style={{ width: '100%', backgroundColor: 'rgba(255,255,255,0.4)' }}></div>
                                                            </div>
                                                            <span className="progress-description text-white">
                                                                일일 접수건수
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* 대용량보일러접수건수 */}
                                                <div className="col-md-3 col-sm-6">
                                                    <div className="info-box bg-warning">
                                                        <span className="info-box-icon">
                                                            <i className="fas fa-fire"></i>
                                                        </span>
                                                        <div className="info-box-content">
                                                            <span className="info-box-text text-white">대용량보일러접수건수</span>
                                                            <span className="info-box-number text-white">
                                                                {kpiData.heavyBoilerCount.toLocaleString()}건
                                                            </span>
                                                            <div className="progress" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                                                                <div className="progress-bar" style={{ width: '100%', backgroundColor: 'rgba(255,255,255,0.4)' }}></div>
                                                            </div>
                                                            <span className="progress-description text-white">
                                                                일일 대용량 보일러 접수 건수
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* 보상판매/판매건수 */}
                                                <div className="col-md-3 col-sm-6">
                                                    <div className="info-box bg-success">
                                                        <span className="info-box-icon">
                                                            <i className="fas fa-dollar-sign"></i>
                                                        </span>
                                                        <div className="info-box-content">
                                                            <span className="info-box-text text-white">보상판매건수</span>
                                                            <span className="info-box-number text-white">
                                                                {kpiData.compSaleCount.toLocaleString()}건
                                                            </span>
                                                            <div className="progress" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                                                                <div className="progress-bar" style={{ width: '100%', backgroundColor: 'rgba(255,255,255,0.4)' }}></div>
                                                            </div>
                                                            <span className="progress-description text-white">
                                                                일일 보상판매/판매 접수 건수
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>

                                                {/* 1년이내보일러접수건수 */}
                                                <div className="col-md-3 col-sm-6">
                                                    <div className="info-box bg-danger">
                                                        <span className="info-box-icon">
                                                            <i className="fas fa-calendar-check"></i>
                                                        </span>
                                                        <div className="info-box-content">
                                                            <span className="info-box-text text-white">1년 6개월이내 보일러</span>
                                                            <span className="info-box-number text-white">
                                                                {kpiData.recentBoilerCount.toLocaleString()}건
                                                            </span>
                                                            <div className="progress" style={{ backgroundColor: 'rgba(255,255,255,0.2)' }}>
                                                                <div className="progress-bar" style={{ width: '100%', backgroundColor: 'rgba(255,255,255,0.4)' }}></div>
                                                            </div>
                                                            <span className="progress-description text-white">
                                                                신규 보일러 접수(대용량 제외)
                                                                {kpiData.recentBoilerCount > 10 && (
                                                                    <span className="ms-2">
                                                                        <i className="fas fa-exclamation-triangle"></i>
                                                                    </span>
                                                                )}
                                                            </span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                        {/* ===== KPI 섹션 끝 ===== */}

                        {/* 고급 검색 필터 */}
                        <SearchFilter
                            searchParams={search}
                            onSearchChange={handleSearchChange}
                            onSearch={onSearch}
                            onClearFilter={onClearFilter}
                            onClearManufactureMonthFilter={onClearManufactureMonthFilter}
                            todayButtonName={"접수 Today"}
                            onTodaySearch={null}
                            showStatusFilter={true}
                            showTypeFilter={true}
                            showDateRange={true}
                            showDateType={true}
                            showManufactureMonthRange={true}
                            showModelName={true}
                            showRepairNote={true}
                            dateTypeOptions={dateTypeOptions}
                            onOpenCreate={onOpenCreate}
                            placeholder="고객명, 연락처, 보일러명 등 검색"
                        />

                        {/* 목록 */}
                        <div className="card card-outline card-dark">
                            <div className="card-header">
                                <div className="card-title">접수 목록</div>
                                <div className="card-tools">
                                    <span className="badge bg-secondary">
                                        {PageUtil.formatToKRW(params.total)} 건
                                    </span>
                                </div>
                            </div>
                            <div className="card-body table-responsive p-0">
                                {list.length === 0 ? (
                                    <NoData />
                                ) : (
                                    <table className="table  text-nowrap">
                                        <thead>
                                            <tr>
                                                <th style={{ minWidth: 120 }}>처리상황</th>
                                                <th>처리유형</th>
                                                <th>접수일자</th>
                                                <th>연락처</th>
                                                <th>고객명</th>
                                                <th>보일러명</th>
                                                <th>제조년월</th>
                                                <th>특이사항</th>
                                                <th>수리내역</th>
                                                {/* <th>결제내역</th> */}
                                                <th>접수내용</th>
                                                <th>처리내용</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {list.map((row) => (
                                                <tr key={row.id} style={row.blacklist ? { backgroundColor: '#ffe6e6' } : {}}>
                                                    <td>
                                                        <select
                                                            className="form-select form-select-sm"
                                                            value={row.status || ''}
                                                            onChange={(e) => onChangeStatus(row, e.target.value)}
                                                            style={{
                                                                color: row.status === 'ARREARS' ? '#dc3545' : '',
                                                                fontWeight: row.status === 'ARREARS' ? 'bold' : '',
                                                                fontSize: row.status === 'ARREARS' ? '15px' : '',
                                                            }}
                                                        >
                                                            {params.statusSet.map((s) => (
                                                                <option key={s.value} value={s.value} style={{ textAlign: 'center' }}>
                                                                    {s.label}
                                                                </option>
                                                            ))}
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <span
                                                            className={"badge " + (row.type == ReceptionType.NEW_EXCHANGE || row.type == ReceptionType.EXCHANGE ? ' bg-danger' : 'bg-info')}
                                                            style={{ fontSize: '15px', padding: '5px 10px' }} // 글자 크기와 여백 추가
                                                        >
                                                            {getReceptionType().find((t) => t.value === row.type)?.label || row.type}
                                                        </span>
                                                    </td>
                                                    <td style={{ fontSize: '15px', fontWeight: 'bold' }}>
                                                        {row.receivedDate || ''}
                                                    </td>
                                                    <td>
                                                        <a onClick={() => onOpenEdit(row)} style={{ cursor: 'pointer' }}>
                                                            {row.phone1 || ''}
                                                        </a>
                                                    </td>
                                                    <td>
                                                        <strong>{row.customerName || ''}</strong>
                                                    </td>
                                                    <td>
                                                        <code>{(row.items?.find(p => p.kind === ReceptionItemKind.BOILER)?.modelName || '') + (row.items?.filter(p => p.kind === ReceptionItemKind.BOILER)?.length > 1 ? ' 外' : '')}</code>
                                                    </td>
                                                    <td>
                                                        <small>{row?.items?.find(p => p.manufactureMonth)?.manufactureMonth || ''}</small>
                                                    </td>
                                                    <td>
                                                        <small className="text-warning">
                                                            {row.items?.filter(p => p.note).map(p => p.note).join(', ') || ''}
                                                        </small>
                                                    </td>
                                                    <td>
                                                        {row.repairNote && row.repairNote.length > 10 ? `${row.repairNote.substring(0, 10)}...` : (row.repairNote || '')}
                                                    </td>
                                                    {/* <td>
                                                        <span className="badge bg-secondary">
                                                            {getPaymentMethod().find((p) => p.value === row.paymentMethod)?.label || row.paymentMethod}
                                                        </span>
                                                    </td> */}
                                                    <td>
                                                        <small>{row.requestNote && row.requestNote.length > 10
                                                            ? `${row.requestNote.substring(0, 10)}...`
                                                            : (row.requestNote || '')
                                                        }</small>
                                                    </td>
                                                    <td>
                                                        <small>{row.handleNote && row.handleNote.length > 10
                                                            ? `${row.handleNote.substring(0, 10)}...`
                                                            : (row.handleNote || '')
                                                        }</small>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                )}
                            </div>

                            {/* 페이징 */}
                            {list.length > 0 && (
                                <PaginationControl
                                    page={params.search.page}
                                    total={params.total}
                                    limit={params.search.rows}
                                    changePage={(page) => {
                                        const cur = PageUtil.deepCopy(params);
                                        cur.search.page = page;
                                        setParams(cur);
                                        setSearch(true);
                                    }}
                                    ellipsis={1}
                                />
                            )}
                        </div>
                    </div>
                </>
            ) : (
                <Loading />
            )}
        </>
    );
};

export default ReceptionV;